













import { Component, Prop, Vue } from 'vue-property-decorator';
@Component
export default class Label extends Vue {
  @Prop(String)
  readonly name!: string;

  @Prop(String)
  readonly type!: string;

  @Prop([String, Object])
  readonly link: string | Object | undefined;
}
